import React from 'react';

function ReadingPage() {
    return (
        <>
        <h2>Reading Page</h2>
        <p>HowellCo creates is in incubator for software applications and also does identity and security consulting work. </p>
        </>
    );
}

export default ReadingPage;